// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.TrainingChecklistTable {
  --border: 1px solid rgba(0, 0, 0, 0.15);
}
.Table.TrainingChecklistTable table {
  --sp-table-header-bg: #f6f7f9;
  background-color: #fff;
  border-width: 1px 0;
}
.Table.TrainingChecklistTable table .TableRow {
  display: flex;
  align-items: stretch;
  width: 100%;
}
.Table.TrainingChecklistTable table .TableRow + .TableRow,
.Table.TrainingChecklistTable table .TableRow + .Table-End {
  border-top: var(--border);
}
.Table.TrainingChecklistTable table .TableRow.selected {
  background-color: var(--vt-selected-shading);
}
.Table.TrainingChecklistTable table .TableRow.TableRow-Header {
  border-bottom: var(--border);
}
.Table.TrainingChecklistTable table .TableRow.TableRow-Header .TableCell-Content {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
}
.Table.TrainingChecklistTable table .TableRow.TableRow-Header > .CATEGORY .TableCell-Content {
  justify-content: flex-start;
}
.Table.TrainingChecklistTable table .TableRow .TableCell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;
}
.Table.TrainingChecklistTable table .TableRow .TableCell .TableCell-Content {
  padding: 0.35rem;
  align-content: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  min-width: 0;
  width: 100%;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.CATEGORY {
  flex: 1.5;
  justify-content: flex-start;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.CATEGORY .TableCell-Content {
  white-space: normal;
  word-break: break-word;
  text-align: start;
  padding-left: 1rem;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.STATUS {
  flex: 0 0 8rem;
  overflow: visible;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.STATUS .TableCell-Content {
  overflow: visible;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.STATUS .badge {
  font-size: 1rem;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.TRAINER {
  flex: 1;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.ACTION {
  flex: 0 0 14rem;
  overflow: visible;
}
.Table.TrainingChecklistTable table .TableRow .TableCell.ACTION .TableCell-Content {
  overflow: visible;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/components/TrainingChecklistTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;AADF;AAEE;EACE,6BAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,oBAAA;EACA,WAAA;AAAN;AAEM;;EAEE,yBAAA;AAAR;AAGM;EACE,4CAAA;AADR;AAIM;EACE,4BAAA;AAFR;AAGQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADV;AAIU;EACE,2BAAA;AAFZ;AAOM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AALR;AAOQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AALV;AAQQ;EACE,SAAA;EACA,2BAAA;AANV;AAQU;EACE,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AANZ;AAUQ;EACE,cAAA;EACA,iBAAA;AARV;AAUU;EACE,iBAAA;AARZ;AAUU;EACE,eAAA;AARZ;AAYQ;EACE,OAAA;AAVV;AAaQ;EACE,eAAA;EACA,iBAAA;AAXV;AAaU;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;AAXZ","sourcesContent":["@import '../../../../globals.scss';\n\n.Table.TrainingChecklistTable {\n  --border: 1px solid rgba(0, 0, 0, 0.15);\n  table {\n    --sp-table-header-bg: #f6f7f9;\n    background-color: #fff;\n    border-width: 1px 0;\n\n    .TableRow {\n      display: flex;\n      align-items: stretch;\n      width: 100%;\n\n      + .TableRow,\n      + .Table-End {\n        border-top: var(--border);\n      }\n\n      &.selected {\n        background-color: var(--vt-selected-shading);\n      }\n\n      &.TableRow-Header {\n        border-bottom: var(--border);\n        .TableCell-Content {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-weight: 800;\n        }\n        > .CATEGORY {\n          .TableCell-Content {\n            justify-content: flex-start;\n          }\n        }\n      }\n\n      .TableCell {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n        min-width: 0;\n\n        .TableCell-Content {\n          padding: 0.35rem;\n          align-content: center;\n          text-align: center;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-weight: 700;\n          min-width: 0;\n          width: 100%;\n        }\n\n        &.CATEGORY {\n          flex: 1.5;\n          justify-content: flex-start;\n\n          .TableCell-Content {\n            white-space: normal;\n            word-break: break-word;\n            text-align: start;\n            padding-left: 1rem;\n          }\n        }\n\n        &.STATUS {\n          flex: 0 0 8rem;\n          overflow: visible;\n\n          .TableCell-Content {\n            overflow: visible;\n          }\n          .badge {\n            font-size: 1rem;\n          }\n        }\n\n        &.TRAINER {\n          flex: 1;\n        }\n\n        &.ACTION {\n          flex: 0 0 14rem;\n          overflow: visible;\n\n          .TableCell-Content {\n            overflow: visible;\n            padding-left: 1.5rem;\n            padding-right: 1.5rem;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
